/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <b-modal
    v-model="showModal"
    size="lg"
    no-fade
    id="listing-modal-filters"
    modal-class="bcm-modal listing-modal-filters slide-up modal-fullscreen"
    :hide-footer="true"
    ref="filtersModal"
  >
    <template slot="modal-header" slot-scope="{ close }">
      <h1 class="title">{{$t('filters-product')}}</h1>
      <button class="btn btn-icon btn-icon-small btn-icon-border-black btn-rounded" @click="close()">
        <svg class="o-icon stroke-black"><use xlink:href="#close"></use></svg>
      </button>
    </template>
    <div class="wrapp-listing-filter">
      <filters
        class="collapse-container"
        @close="closeModal"
        @changeFilter="applyFilters"
      />
    </div>
  </b-modal>
</template>

<script>
import Filters from 'theme/components/Listing/Filters'

export default {
  name: 'ListingModalFilters',
  props: {
    value: {
      type: Boolean,
      required: false
    },
    filtersAvailable: {
      type: Object,
      required: true
    }
  },
  computed: {
    showModal: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('close', newValue)
      }
    }
  },
  methods: {
    applyFilters () {
      return this.$emit('changeFilter')
    },
    closeModal () {
      this.showModal = false
    }
  },
  components: {
    Filters
  }
}
</script>
